import { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { useTheme } from '@mui/material/styles';

import { setLanguage } from '@common/Util';

const LegalNotice = () => {
  const [html, setHtml] = useState('');
  const theme = useTheme();

  const language = setLanguage().toLowerCase();

  const link = theme?.footer?.legalNotice?.[language || 'en'];

  const replaceHeader = language === 'de' ? 'Haftungshinweis' : 'Disclaimer';

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(link);
        const content = await response.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(content, 'text/html');

        const em = doc.querySelector('em');
        if (!em) {
          setHtml(doc.body.innerHTML);
          return;
        }

        const textblock = em.textContent + '.';
        const disclaimerH2 = Array.from(doc.querySelectorAll('h2')).find(
          (h2) => h2.textContent.trim() === replaceHeader
        );

        if (disclaimerH2) {
          const span = doc.createElement('span');
          span.textContent = textblock;

          disclaimerH2.insertAdjacentElement('afterend', span);
        }

        let next = em.nextSibling;
        if (next && next.nodeType === Node.TEXT_NODE && next.textContent.trim() === '.') {
          next.remove();
          next = em.nextSibling;
        }

        // delete <p><br></p> elements
        doc.querySelectorAll('p').forEach((p) => {
          if (p.childNodes.length === 1 && p.firstChild.tagName?.toLowerCase() === 'br') {
            p.remove();
          }
        });

        em.remove();

        setHtml(doc.body.innerHTML);
      } catch (err) {
        console.error('Error:', err);
      }
    };

    fetchData();
  }, [link]);

  return (
    <Container maxWidth='md' sx={{ mt: 4, mb: 4, minHeight: '90vh' }}>
      <Box
        sx={{
          '& h2': {
            marginTop: '1rem',
            color: theme.palette.primary.contrastText
          }
        }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </Container>
  );
};
export default LegalNotice;
